import {AbstractReactComponent, ff, i18n, Icon} from 'mc/lib';
import {Form, FormActions, FormBody} from 'mc/lib/form';
import {requireFields} from 'mc/lib/utils';
import PropTypes from 'prop-types';
import React from 'react';
import {Alert, Button} from 'reactstrap';
import {propTypes, reduxForm} from 'redux-form';
import {Api} from '../../api';

const validateRequiredFields = requireFields(['email', 'password', 'passwordAgain']);

class RegisterForm extends AbstractReactComponent {

    static formName = 'register';

    static propTypes = {
        idTypZabor: PropTypes.number,
        onRegister: PropTypes.func.isRequired,
        ...propTypes,
    };

    static validate = values => {
        const errors = validateRequiredFields(values);

        const {password, passwordAgain} = values;
        if (password && passwordAgain && password !== passwordAgain) {
            errors.passwordAgain = i18n('registerForm.notSamePasswords');
        }

        return errors;
    };

    onSubmit = (data) => {
        return Api.register(data.email, data.password, data.firstname, data.lastname, this.props.idTypZabor).then(() => {
            this.props.onRegister();
        })
    };

    render() {
        const {error, handleSubmit, pristine, submitting, onClose} = this.props;

        return (
            <Form onSubmit={handleSubmit(this.onSubmit)} prefix="registerForm.field">
                <FormBody>
                    <p>{i18n('registerForm.info')}</p>
                    {error && <Alert color="danger">{error}</Alert>}
                    <ff.String name="email" label={false} type="email" placeholder={i18n('registerForm.email')} autoComplete="off" required />
                    <ff.String name="password" label={false} type="password" placeholder={i18n('registerForm.password')} autoComplete="off" required/>
                    <ff.String name="passwordAgain" label={false} type="password" placeholder={i18n('registerForm.passwordAgain')} autoComplete="off" required/>
                    <ff.String name="firstname" label={false} placeholder={i18n('registerForm.firstname')} autoComplete="off"/>
                    <ff.String name="lastname" label={false} placeholder={i18n('registerForm.lastname')} autoComplete="off"/>
                </FormBody>
                <FormActions>
                    <Button className="pull-left" onClick={onClose}>Zavřít</Button>
                    <Button color="primary" type="submit" disabled={pristine || submitting}>
                        {submitting ? <Icon icon="spinner" animation={Icon.animation.spin}/> : null} {i18n('registerForm.submit')}
                    </Button>
                </FormActions>
            </Form>
        )
    }
}

const formConfig = {
    form: RegisterForm.formName,
    validate: RegisterForm.validate,
};

export default reduxForm(formConfig)(RegisterForm);
